import TitleBar from "@components/Layout/TitleBar";
import SEO from "@components/SEO";
import Contact from "@components/PageComponents/Contact";

import { motion } from "framer-motion";
import { NextPage } from "next";

const Contacts: NextPage = () => {
  return (
    <motion.div className="container-padding container-margin container" exit={{ opacity: 0 }}>
      <SEO
        pageTitle="Contact | DeathroW Esport"
        pageDescription="Contactez Deathrow, un club esport français, formateur de talents sur la scène Rainbow Six Siege."
      />

      <TitleBar subtitle="Etre en relation avec Deathrow">Nous contacter</TitleBar>

      <Contact />
    </motion.div>
  );
};

export default Contacts;
